import type { ReferralSurfaceIncentive } from "./referral-surface-copy";

/**
 * Referral discovery-surface funnel: shown → dismissed | clicked(action).
 * Mirrors marketplace-analytics' idiom — every helper builds the COMPLETE
 * property bag itself from enumerated inputs, so no caller can smuggle the
 * referral token or share URL into an event (ADR-030 D13/D18). The backend's
 * referral events are `{kind}`-only for the same reason.
 */
export type ReferralCapture = (
  event: string,
  properties?: Record<string, unknown>,
) => void;

export type ReferralSurface = "banner" | "publish_prompt" | "waitlist_card";
export type ReferralShareAction = "copy" | "text" | "email";

export const REFERRAL_SURFACE_EVENTS = {
  shown: "referral_surface_shown",
  dismissed: "referral_surface_dismissed",
  clicked: "referral_surface_clicked",
} as const;

export function captureReferralSurfaceShown(
  capture: ReferralCapture,
  surface: ReferralSurface,
  incentive: ReferralSurfaceIncentive,
) {
  capture(REFERRAL_SURFACE_EVENTS.shown, { surface, incentive });
}

export function captureReferralSurfaceDismissed(
  capture: ReferralCapture,
  surface: ReferralSurface,
  incentive: ReferralSurfaceIncentive,
) {
  capture(REFERRAL_SURFACE_EVENTS.dismissed, { surface, incentive });
}

export function captureReferralSurfaceClicked(
  capture: ReferralCapture,
  surface: ReferralSurface,
  incentive: ReferralSurfaceIncentive,
  action: ReferralShareAction,
) {
  capture(REFERRAL_SURFACE_EVENTS.clicked, { surface, incentive, action });
}
